import * as React from 'react';
import { SVGProps } from 'react';

const SvgIcTag = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1600"
    height="1600"
    viewBox="0 0 1200 1200"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path
        fill="currentColor"
        d="M15.137 15.273C5.047 25.363-.34 39.234.028 53.402l13.594 514.19c.355 13.773 6.012 26.699 15.656 36.34l580.55 580.55c20.223 20.223 54.039 20.973 74.551.477l500.61-500.61c20.496-20.508 19.73-54.301-.492-74.523l-580.53-580.54c-9.63-9.641-22.594-15.328-36.312-15.695L53.455.009C39.244-.36 25.31 5.11 15.205 15.255zm39.109 38.961 511.49 13.488 579.61 579.63-498.04 498.04-579.55-579.55-13.527-511.61m162.07 162.11c-47.371 47.387-47.371 125.02 0 172.41 47.371 47.387 125.02 47.387 172.39 0 47.387-47.387 47.371-125.02 0-172.41s-125.02-47.387-172.39 0m38.305 38.305c26.672-26.672 69.094-26.672 95.727 0 26.672 26.672 26.672 69.109 0 95.727-26.672 26.672-69.094 26.672-95.727 0-26.672-26.672-26.672-69.094 0-95.727"
      ></path>
    </g>
  </svg>
);

export default SvgIcTag;
